module.exports = __webpack_public_path__ + "img/link.32ab75e9.png";